import React, { useState } from "react";
import { CheckCircle2, X, ShieldCheck } from "lucide-react";

const PROOFS = [
  {
    src: "https://customer-assets.emergentagent.com/job_quick-sarf/artifacts/2n4sssee_IMG_6956.jpeg",
    caption: "تحويل مصرف الراجحي",
    note: "تم لاهنت بيض الله وجهك",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_quick-sarf/artifacts/ezutdm3j_IMG_6954.jpeg",
    caption: "تم التحويل بنجاح",
    note: "عشت جتني — بيض الله وجهك",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_quick-sarf/artifacts/klzshxcs_IMG_6955.jpeg",
    caption: "تحويل مبلغ 2,193 ريال",
    note: "وصلت — جعل والديك بالجنة",
  },
];

export default function TransferProofs() {
  const [active, setActive] = useState(null);

  return (
    <section id="proofs" className="py-20 md:py-28 bg-white relative overflow-hidden" data-testid="proofs-section">
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(circle at 1px 1px, #0F3D2E 1px, transparent 0)",
          backgroundSize: "28px 28px",
        }}
      />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative">
        <div className="text-center mb-14 fade-up">
          <div className="inline-flex items-center gap-2 text-brand-gold font-bold text-sm tracking-widest uppercase mb-3">
            <ShieldCheck className="w-4 h-4" /> إثباتات حقيقية
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-brand-green leading-tight">
            تحويلات <span className="text-gold-gradient">وصلت بنجاح</span>
          </h2>
          <p className="mt-3 text-base md:text-lg text-brand-ink/70 max-w-2xl mx-auto">
            لقطات حقيقية من محادثات عملائنا بعد استلام السيولة — الثقة لا تُدّعى، تُثبت.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {PROOFS.map((p, i) => (
            <button
              key={i}
              onClick={() => setActive(p)}
              data-testid={`proof-card-${i + 1}`}
              className="group relative bg-brand-bg rounded-3xl overflow-hidden border border-black/5 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 text-right fade-up"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              {/* Image */}
              <div className="relative aspect-[3/4] overflow-hidden bg-gradient-to-b from-brand-green/5 to-brand-green/15">
                <img
                  src={p.src}
                  alt={p.caption}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {/* Verified badge */}
                <div className="absolute top-3 start-3 bg-white rounded-full px-3 py-1.5 flex items-center gap-1.5 shadow-lg">
                  <CheckCircle2 className="w-4 h-4 text-green-600" />
                  <span className="text-xs font-extrabold text-brand-green">موثّق</span>
                </div>
                <div className="absolute bottom-0 inset-x-0 h-1/3 bg-gradient-to-t from-black/60 to-transparent pointer-events-none" />
              </div>

              {/* Caption */}
              <div className="p-5">
                <div className="font-heading font-extrabold text-brand-green text-lg">{p.caption}</div>
                <div className="mt-1.5 text-sm text-brand-ink/65 leading-relaxed">
                  "{p.note}"
                </div>
              </div>

              {/* Hover ring */}
              <div className="absolute inset-0 ring-0 group-hover:ring-2 ring-brand-gold/60 rounded-3xl transition-all pointer-events-none" />
            </button>
          ))}
        </div>

        {/* Trust strip */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 md:gap-10 text-center">
          <div>
            <div className="font-heading text-3xl md:text-4xl font-black text-gold-gradient">+500</div>
            <div className="text-xs md:text-sm text-brand-ink/60 font-semibold">عميل راضٍ</div>
          </div>
          <div className="h-10 w-px bg-brand-gold/30" />
          <div>
            <div className="font-heading text-3xl md:text-4xl font-black text-gold-gradient">+2.5M</div>
            <div className="text-xs md:text-sm text-brand-ink/60 font-semibold">ريال تم تحويلها</div>
          </div>
          <div className="h-10 w-px bg-brand-gold/30" />
          <div>
            <div className="font-heading text-3xl md:text-4xl font-black text-gold-gradient">4.9★</div>
            <div className="text-xs md:text-sm text-brand-ink/60 font-semibold">تقييم العملاء</div>
          </div>
        </div>
      </div>

      {/* Lightbox modal */}
      {active && (
        <div
          className="fixed inset-0 z-[70] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4 fade-up"
          onClick={() => setActive(null)}
          data-testid="proof-lightbox"
        >
          <button
            onClick={() => setActive(null)}
            aria-label="إغلاق"
            className="absolute top-5 end-5 w-11 h-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center backdrop-blur-sm"
            data-testid="proof-lightbox-close"
          >
            <X className="w-6 h-6" />
          </button>
          <img
            src={active.src}
            alt={active.caption}
            onClick={(e) => e.stopPropagation()}
            className="max-w-full max-h-[90vh] rounded-2xl shadow-2xl object-contain"
          />
        </div>
      )}
    </section>
  );
}
